import React from 'react';
import styled from 'styled-components';
import { DataElementContext } from '@/page-components/common/DataElementContext';
import { useSafeNavigate } from '@/components/utils/hooks/useSafeNavigate';
import { AUTH_GLOBAL_ERROR_CODES } from '@/constants/authErrorCode';
import { useAppSelector } from '@/store';

//import './index.scss';

type TemplateProps = {
  children: any;
  styleText: string;
  className: string;
  properties?: any;
};

const ModuleElementDiv = styled.div<{ $styleText: string }>((props) => props.$styleText);

const Deeplinks = (componentProps: TemplateProps) => {
  // let props = componentProps;
  const globalAuthenticationError = useAppSelector((state) => state.authentication.globalAuthenticationError);
  const [timer, setTimer] = React.useState<NodeJS.Timeout | null>(null);
  // const dataElementContext = React.useContext(DataElementContext);
  // [props] = processComponentProps(props, dataElementContext);

  const navigate = useSafeNavigate();

  const goToMobileApps = React.useCallback(() => {
    // if we are in a deeplink and the application is not initialized, we can navigate to mobile-apps

    navigate('/mobile-apps');
  }, [navigate]);

  React.useEffect(() => {
    if (AUTH_GLOBAL_ERROR_CODES.MIGRATION_IN_PROGRESS === globalAuthenticationError) {
      return;
    }
    const lTimer = setTimeout(() => goToMobileApps(), 0);
    setTimer(lTimer);
    return () => {
      if (lTimer) {
        clearTimeout(lTimer);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const contextValue = React.useMemo(() => {
    return {};
    // }, [dataElementContext, componentProps]);
  }, []);

  return (
    <ModuleElementDiv className={componentProps.className ?? ''} $styleText={componentProps.styleText}>
      <DataElementContext.Provider value={contextValue}>{componentProps.children}</DataElementContext.Provider>
    </ModuleElementDiv>
  );
};

export default Deeplinks;
